var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 70,
    viewBox: "0 0 417 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209 35C223.139 35 235.32 26.616 240.842 14.5483C244.29 7.01536 250.716 0 259 0H402C410.284 0 417 6.71573 417 15V55C417 63.2843 410.284 70 402 70H15C6.71573 70 0 63.2843 0 55V15C0 6.71573 6.71573 0 15 0H159C167.284 0 173.71 7.01536 177.158 14.5483C182.68 26.616 194.861 35 209 35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationHome);
export default __webpack_public_path__ + "static/media/navigation_home.b0e1cc2945501e1fae63b65d5f132dbc.svg";
export { ForwardRef as ReactComponent };